module.exports = __webpack_public_path__ + "resources/img/img_security_TLS_SSL_certificate1_m.ca857016f9331a03d417d71b3cd4a402.png";